import { Anchor, Box, BoxProps, Breadcrumbs as BreadcrumbsContainer } from '@mantine/core';
import { IconChevronRight as RightIcon } from '@tabler/icons-react';
import { Link as RouterLink } from '@tanstack/react-router';

import { useBreadcrumbs } from '@feature/utils';

import classes from './Breadcrumbs.module.css';

export type BreadcrumbsProps = BoxProps;

export function Breadcrumbs(props: BreadcrumbsProps) {
  const items = useBreadcrumbs();
  return (
    <Box {...props}>
      <BreadcrumbsContainer
        fs="xs"
        separator={<RightIcon className={classes.icon} />}
      >
        {items.map(item => (
          <Anchor
            component={RouterLink}
            key={item.id}
            to={item.to}
            // @ts-expect-error weird type
            params={item.params}
            disabled={item.isActive}
            className={classes.item}
            data-active={item.isActive}
            underline="hover"
            fz="sm"
          >
            {item.label.length > 20 ? `${item.label.substring(0, 20)}....` : item.label}
          </Anchor>
        ))}
      </BreadcrumbsContainer>
    </Box>
  );
}
